import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div<{
    show: boolean,
    showScroll: boolean,
    height: string
}>`
    visibility: ${({ show }) => show ? 'visible' : 'hidden'};
    height: ${({ show, height }) => show ? height : '0'};
    overflow: ${({ show, showScroll }) =>
        show && showScroll ? 'auto' : 'hidden'};
    width: 100%;
`;

type Props = {
    activeTab: number | string,
    tab: number | string,
    className?: string,
    showScroll?: boolean,
    height?: string,
    open?: boolean,
}

export const TabPanel: React.FC<Props> = ({
    activeTab,
    tab,
    children,
    className,
    showScroll = true,
    height = '100%',
}) => {
    const [show, setShow] = React.useState<boolean>(activeTab === tab);

    React.useEffect(() => {
        const shouldShow = activeTab === tab;
        setShow(shouldShow);
    }, [activeTab, tab]);

    if (!show) {
        return null;
    }

    return (
        <Wrapper
            className={className}
            height={height}
            showScroll={showScroll}
            show={show}>
            { children }
        </Wrapper>
    );
};
